import React, { useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';

export type GroupAssignedProps = {
    show?: boolean
    onClose: (yes: boolean) => void;
    message?: string;
}

const GroupAssigned: React.FC<GroupAssignedProps> = (props) => {
    const { data: userProfile } = UserApi.useGetUserProfileQuery();

    const handleClose = () => {
        props.onClose && props.onClose(false);
    };

    const handleConfirm = () => {
        // Logic to assign the ticket to the current user before closing
        //console.log('Ticket assigned to the current user and closed.');
        props.onClose && props.onClose(true);
    };

    if (!props.show) return null;

    return (
        <div>
            <Dialog className='cool-window' title={"Assign to yourself?"} onClose={handleClose} width={400}>
                <p>{props.message ? props.message : `The ${userProfile?.Phrases.CallPhrase} cannot be closed when exclusively assigned to a Group. Would you like to assign the ${userProfile?.Phrases.CallPhrase} to yourself before closing?`}</p>
                <DialogActionsBar layout='center'>
                    <Button size='large' svgIcon={svg.checkIcon} onClick={handleConfirm} style={{ backgroundColor: 'rgb(115, 169, 19)', color: 'white' }}>
                        Yes
                    </Button>
                    <Button size='large' svgIcon={svg.xIcon} fillMode='outline' onClick={handleClose}>
                        No
                    </Button>
                </DialogActionsBar>
            </Dialog>
        </div >
    );
};

export default GroupAssigned;